/**
 * Combine two canvases (base + overlay) into a single image (DataURL).
 * The target canvas is used only as a temporary renderer.
 */
export const overlayCanvasOnBuffer = async (
  base: HTMLCanvasElement,
  buffer: Uint8Array,
  overlay: HTMLCanvasElement,
  options?: {
    x?: number
    y?: number
    composite?: GlobalCompositeOperation
    format?: string // e.g. 'image/png', 'image/jpeg'
    quality?: number // for jpeg/webp
  },
): Promise<string> => {
  const { x = 0, y = 0, composite = 'source-over', format = 'image/png', quality = 1.0 } = options || {}

  const ctx = base.getContext('2d')
  if (!ctx) throw new Error('2D context not supported')

  // Draw base from buffer
  const imageData = new ImageData(new Uint8ClampedArray(buffer), base.width, base.height)
  const bitmap = await createImageBitmap(imageData, {
    imageOrientation: 'flipY', // handles the vertical flip for you
  })
  ctx.drawImage(bitmap, 0, 0)

  // Compute scaled size for overlay
  const scale = base.width / overlay.width // same ratio assumed
  const overlayWidth = overlay.width * scale
  const overlayHeight = overlay.height * scale
  ctx.globalCompositeOperation = composite
  ctx.drawImage(overlay, x, y, overlayWidth, overlayHeight)

  ctx.globalCompositeOperation = 'source-over'

  // Return final as DataURL
  return base.toDataURL(format, quality)
}
